import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const YoutubeOutlined24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.youtubeFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm0 1.198C6.815 2.198 2.198 6.815 2.198 12.5S6.815 22.802 12.5 22.802 22.802 18.185 22.802 12.5 18.185 2.198 12.5 2.198zm.27 6.39c.848.006 3.285.04 3.986.227.472.126.843.497.969.968.196.732.224 2.145.228 2.534v.202c-.004.39-.032 1.802-.228 2.534a1.371 1.371 0 01-.969.968c-.732.196-3.353.224-4.087.228h-.384c-.734-.004-3.355-.032-4.088-.228a1.371 1.371 0 01-.968-.968c-.185-.69-.22-1.99-.227-2.46v-.35c.006-.47.042-1.769.227-2.46.126-.47.497-.842.968-.968.702-.188 3.138-.221 3.986-.227h.587zM11.5 10.75V14l2.75-1.625-2.75-1.625z"
      fillRule="evenodd"
    />
  </svg>
);

export default YoutubeOutlined24;
